/**************************************************
 * Nombre:       Sostenibilidad_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import logo from "../../../Recursos/logo_rojo.svg";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../../Utilidades/irUrl";

const Adicional_Portada = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 18}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                    <Typography sx={{
                                        fontSize: sCell ? 32 : 40,
                                        fontWeight: 800,
                                        color: theme.palette.primary.main,
                                        lineHeight: 1.2,
                                        textAlign: sCell ? 'center' : 'left'
                                    }}>

                                        {item.nombre}
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Typography sx={{textAlign: 'justify'}}>
                                        {item.descripcion}
                                    </Typography>
                                </Grid>

                                {item.botonTexto && item.link &&

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 4}}>
                                        <Button
                                            onClick={() => irUrl(item.link)}
                                            sx={{px: 6}}
                                        >{item.botonTexto}</Button>
                                    </Grid>
                                }

                            </Grid>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-end', mt: sCell ? 4 : 0}}>
                            <img src={item.img ? item.img : logo} width={sCell ? '100%' : '70%'} height={'auto'}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Adicional_Portada